import { useState } from "react";
import Widget from "components/widget/Widget";
import RevenueTable from "./components/RevenueTable";
import DateRangePicker from "./components/DateRangePicker";
import { RevenueDateRange } from "types/revenue";
import { MdAttachMoney, MdTrendingUp } from "react-icons/md";

const RevenueView = () => {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  const [dateRange, setDateRange] = useState<RevenueDateRange>({
    startDate: yesterday,
    endDate: new Date(),
  });

  const [totalRevenueSol, setTotalRevenueSol] = useState<number>(0);
  const [totalTransactions, setTotalTransactions] = useState<number>(0);
  const [solToUsdRate, setSolToUsdRate] = useState<number>(0);

  const totalRevenueInUsd = totalRevenueSol * solToUsdRate;

  const formatNumber = (num: number): string => {
    return new Intl.NumberFormat().format(num);
  };

  const formatCurrency = (amount: number): string => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(amount);
  };

  return (
    <div>
      <div className="mb-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="text-2xl font-bold text-navy-700">Fees Dashboard</div>
        <DateRangePicker
          dateRange={dateRange}
          onDateRangeChange={setDateRange}
        />
      </div>

      <div className="mt-3 w-full flex flex-wrap gap-4 items-center">
        <div className="w-fit">
          <Widget
            icon={<MdTrendingUp className="h-7 w-7" />}
            title={"Total Swaps"}
            subtitle={
              totalTransactions ? formatNumber(totalTransactions) : "Loading..."
            }
          />
        </div>
        <div className="w-fit">
          <Widget
            icon={<MdAttachMoney className="h-7 w-7" />}
            title={"Total Fees (SOL)"}
            subtitle={
              totalRevenueSol
                ? `${totalRevenueSol.toFixed(6)} SOL`
                : "Loading..."
            }
          />
        </div>
        <div className="w-fit">
          <Widget
            icon={<MdAttachMoney className="h-7 w-7" />}
            title={"Total Fees (USD)"}
            subtitle={formatCurrency(totalRevenueInUsd)}
          />
        </div>
      </div>

      <div className="mt-5 grid grid-cols-1 gap-5">
        <div className="w-full">
          <RevenueTable
            dateRange={dateRange}
            onTotalsUpdate={(transactions, revenueSol, usdRate) => {
              setTotalTransactions(transactions);
              setTotalRevenueSol(revenueSol);
              setSolToUsdRate(usdRate);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default RevenueView;
